export const check_circle = () => (
  <>
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m16 9-5.5 5L8 11.727"
    />
  </>
);
